import { IDemo, DemoIds } from 'types'
import { getSharedAsset } from '../../helpers/utils'

const video = getSharedAsset('transformation-of-healthcare.mp4', 'demos', 'videos')
const poster = getSharedAsset('transformation-of-healthcare.png', 'demos', 'posters')
const monolith = getSharedAsset('transformation-of-healthcare.png', 'demos', 'monoliths')
const nextDemoThumbnail = getSharedAsset('osirix.png', 'demos', 'thumbnails')

export const transformationOfHealthcare: IDemo = {
  id: DemoIds.transformationOfHealthcare,
  type: 'avesha',
  video,
  poster,
  monolith,
  end: {
    header: 'The transformation of healthcare.',
    body:
      'Avesha Systems is working with several hospitals to test how machine learning inference done at the edge utilizing Wavelength and Verizon 5G can assist doctors in identifying polyps in real-time.',
    nextDemoText: 'Access and share high-resolution medical images.',
    nextDemoId: DemoIds.osirix,
    nextDemoThumbnail,
    previousDemoId: DemoIds.mecAndSmartVenues
  }
}
